import { MapLayoutEditor } from "@/components/map-layout/MapLayoutEditor";

export function MapLayoutPage() {
  return <MapLayoutEditor />;
}
